import { InjectionToken } from '@angular/core';
import {
  TimeseriesQueryParams,
  TimeseriesResult,
} from '../../domain/models/timeseries.model';

export interface TimeseriesRepositoryPort {
  query(params: TimeseriesQueryParams): Promise<TimeseriesResult>;
}

export const TIMESERIES_REPOSITORY =
  new InjectionToken<TimeseriesRepositoryPort>('TimeseriesRepository');
